import { render, staticRenderFns } from "./EditNomTipDoc.vue?vue&type=template&id=4e47d85a&scoped=true&"
import script from "./EditNomTipDoc.ts?vue&type=script&lang=ts&"
export * from "./EditNomTipDoc.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e47d85a",
  null
  
)

export default component.exports
import {QForm,QSelect,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QForm,QSelect,QInput,QBtn}, component.options.components || {})
